// Constants for localStorage keys
export const KEYS = {
  LOGIN_TOKEN_STORE_KEY: 'access_token',
  REFRESH_TOKEN_KEY: 'refresh_token',
  FACTORY_ID_KEY: 'factoryId',
  MANAGER_ID_KEY: 'managerId',
} as const;
